<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import required from "vuelidate/lib/validators/required";
import { cloneDeep, groupBy } from "lodash";
import { Carousel, Slide } from "vue-carousel";
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Employee from "@/components/modals/employee.vue";
import ExternalEmployee from "@/components/modals/employee-hris.vue";
import Location from "@/components/modals/property-location.vue";
import Disposal from "@/components/modals/property-disposal.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import Details from "@/router/views/property/components/details";
import AssignmentHistory from "@/router/views/property/components/assignmenthistory";
import CurrentInventory from "@/router/views/property/components/inventory";
import InspectionHistory from "@/router/views/property/components/inspectionhistory";
import Attachments from "@/router/views/property/components/attachments";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Inspection",
  },
  components: {
    Layout,
    PageHeader,
    Carousel,
    Slide,
    DatePicker,
    MaskedInput,
    Employee,
    ExternalEmployee,
    Location,
    Disposal,
    UploadPopover,
    Details,
    AssignmentHistory,
    CurrentInventory,
    InspectionHistory,
    Attachments,
    RawData,
  },
  data() {
    return {
      title: "Inspection",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Inspection",
          active: true,
        },
      ],
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false,
      }),
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptionsLg: [10, 25, 50, 100],
      pageOptionsSm: [5, 10, 20, 50],
      filter: "",
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "poNumber",
          sortable: true,
          label: "Purchase Order",
        },
      ],
      propertyFields: [
        {
          key: "Name",
          sortable: true,
        },
      ],
      editMode: false,
      itemCategory: "",
      backup: {},
      propertyBackup: {},
      indexSelected: -1,
      tableBusy: false,
      inspection: false,
      property: {},
      form: {
        propertyId: "",
        inspectionDateTime: "",
        propertyStatus: "",
        assessedValue: "",
        inspectionStatus: "",
        employeeId: "",
        employee: {},
      },
      disposeForm: {
        disposalId: null,
        propertyId: null,
        accumulatedDepreciation: null,
        accumulatedImpairmentLosses: null,
        carryingAmount: null,
        appraisedValue: null,
        propertyFinalStatus: "",
        inspectionDate: "",
        inspectedBy: "",
        remarks: "",
      },
      loading: false,
      employeeName: "",
      disposalName: "",
      getEmployeeType: "",
      assignmentHistoryEmployeeData: null,
      assignmentHistoryLocationData: null,
      editInspection: false,
      campusId: this.$store.state.data.selectedCampus.id,
      uploadOptions: {
        type: "Property Inspection",
        placement: "lefttop",
        folder: "Property",
      },
    };
  },
  validations: {
    form: {
      propertyId: { required },
      inspectionDateTime: { required },
      propertyStatus: { required },
      assessedValue: { required },
      inspectionStatus: { required },
      employeeId: { required },
    },
  },
  computed: {
    grouped() {
      var array = [];
      var x = groupBy(this.filtered, "supplier");
      for (const key in x) {
        var supplier = key;
        var y = groupBy(x[key], "poNumber");
        for (const key in y) {
          array.push({
            poNumber: key,
            supplier: supplier,
            details: y[key],
            showDetails: false,
            rotateChevy: false,
            currentPage: 1,
            perPage: 5,
            filter: "",
            tableBusy: false,
          });
        }
      }
      return array;
    },
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.poNumber.toUpperCase().includes(this.filter.toUpperCase())) {
            return item.poNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.supplier.toUpperCase().includes(this.filter.toUpperCase())
          ) {
            return item.supplier
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.name.toUpperCase().includes(this.filter.toUpperCase())
          ) {
            return item.name.toUpperCase().includes(this.filter.toUpperCase());
          } else if (
            item.propertyNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.propertyNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.serialNumber.toUpperCase().includes(this.filter.toUpperCase())
          ) {
            return item.serialNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.grouped.length;
      } else {
        return this.filtered.length;
      }
    },
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
  },
  methods: {
    changeCampus(data) {
      this.campusId = data.id;
      this.getForDisposal();
      this.returnToTable();
    },
    getForDisposal() {
      this.totalRows = this.items.length;
      this.tableBusy = true;
      this.$store
        .dispatch("property/GetPropertyForDisposal", this.campusId)
        .then((res) => {
          this.tableBusy = false;
          res.data.forEach((item) => {
            item.visible = false;
            item.itemVisible = false;
            item.assignmentHistory = [];
            item.assignVisible = false;
            item.assignLoading = false;
            item.inventory = [];
            item.inventoryVisible = false;
            item.inventoryLoading = false;
            item.inspectionVisible = false;
            item.attachmentVisible = false;
            item.addDocu = false;
            item.attachmentLoading = false;
            item.fileSearch = "";
            item.propertyInspections.forEach((inspect) => {
              inspect.inspectionFiles = [];
              inspect.attachmentLoading = false;
            });
          });
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting disposed property list!",
            "error"
          );
        });
    },
    propertyFiltered(row) {
      if (row.showDetails) {
        let data = row.details;
        if (row.filter.trim() != "" && row.filter) {
          data = data.filter((item) => {
            if (item.name.toUpperCase().includes(row.filter.toUpperCase())) {
              return item.name.toUpperCase().includes(row.filter.toUpperCase());
            } else if (
              item.propertyNumber
                .toUpperCase()
                .includes(row.filter.toUpperCase())
            ) {
              return item.propertyNumber
                .toUpperCase()
                .includes(row.filter.toUpperCase());
            } else if (
              item.serialNumber.toUpperCase().includes(row.filter.toUpperCase())
            ) {
              return item.serialNumber
                .toUpperCase()
                .includes(row.filter.toUpperCase());
            }
          });
        }
        return data;
      } else return [];
    },
    propertyRows(row) {
      if (row.filter.trim() != "" && row.filter) {
        return this.propertyFiltered(row).length;
      } else {
        return row.details.length;
      }
    },
    onAdd() {
      this.submitted = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.form.inspectionDateTime = this.getDate(
          this.form.inspectionDateTime
        );
        if (this.editInspection === false) {
          this.$store
            .dispatch("propertyinspection/AddPropertyInspection", this.form)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.showToast("Successfully created!", "success");
              res.data.inspectionFiles = [];
              res.data.attachmentVisible = false;
              res.data.addDocu = false;
              res.data.attachmentLoading = false;
              res.data.fileSearch = "";
              this.property.propertyInspections = [res.data].concat(
                this.property.propertyInspections
              );
              this.loading = false;
              this.onReset();
              this.$bvModal.hide("modal-standard");
            })
            .catch((err) => {
              this.loading = false;
              this.showToast(
                "Something went wrong - Adding inspection!",
                "error"
              );
            });
          this.submitted = false;
        } else {
          this.$store
            .dispatch("propertyinspection/UpdatePropertyInspection", this.form)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.showToast("Successfully created!", "success");
              res.data.inspectionFiles = [];
              res.data.attachmentVisible = false;
              res.data.addDocu = false;
              res.data.attachmentLoading = false;
              res.data.fileSearch = "";
              var index = this.property.propertyInspections.findIndex(
                (item) => item.id == this.form.id
              );
              this.property.propertyInspections.splice(index, 1, res.data);
              this.loading = false;
              this.onReset();
              this.$bvModal.hide("modal-standard");
            })
            .catch((err) => {
              this.loading = false;
              this.showToast(
                "Something went wrong - Adding inspection!",
                "error"
              );
            });
          this.submitted = false;
        }
      }
    },
    postInspection(props) {
      var index = this.property.propertyInspections.indexOf(props);
      this.$swal({
        title: "Are you sure?",
        text: "You are about to post this inspection.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, post it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertyinspection/PostPropertyInspection", props.id)
            .then((res) => {
              this.property.propertyInspections[index].status = "POSTED";
              this.showToast("Successfully Posted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be Posted!", "error");
            });
        }
      });
    },
    unpostInspection(props) {
      var index = this.property.propertyInspections.indexOf(props);
      this.$swal({
        title: "Are you sure?",
        text: "You are about to unpost this inspection.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, unpost it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertyinspection/UnpostPropertyInspection", props.id)
            .then((res) => {
              this.property.propertyInspections[index].status = "PENDING";
              this.showToast("Successfully Unposted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be Unposted!", "error");
            });
        }
      });
    },
    deleteInspection(props) {
      var index = this.property.propertyInspections.indexOf(props);
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertyinspection/DeletePropertyInspection", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.property.propertyInspections.splice(index, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    onReset() {
      this.form = {
        propertyId: "",
        inspectionDateTime: "",
        propertyStatus: "",
        assessedValue: "",
        inspectionStatus: "",
        employeeId: "",
        employee: {},
      };
      this.disposeForm = {
        disposalId: null,
        propertyId: null,
        accumulatedDepreciation: null,
        accumulatedImpairmentLosses: null,
        carryingAmount: null,
        appraisedValue: null,
        propertyFinalStatus: "",
        inspectionDate: "",
        inspectedBy: "",
        remarks: "",
      };
      this.employeeName = "";
      this.disposalName = "";
    },
    createInspection() {
      this.onReset();
      this.form.propertyId = this.property.id;
      this.editInspection = false;
      this.modalTitle = "Add Inspection";
      this.$bvModal.show("modal-standard");
    },
    updateInspection(props) {
      this.onReset();
      this.form = cloneDeep(props);
      this.form.inspectionDateTime = new Date(this.form.inspectionDateTime);
      this.form.employeeId = props.employeeId;
      this.employeeName = props.employee.firstName.concat(
        " ",
        props.employee.lastName
      );
      this.editInspection = true;
      this.modalTitle = "Update Inspection";
      this.$bvModal.show("modal-standard");
    },
    onDispose() {
      this.submitted = true;
      if (this.checkDisposeForm()) {
        return;
      } else {
        this.disposeForm.inspectionDate = this.getDate(
          this.disposeForm.inspectionDate
        );
        this.$store
          .dispatch(
            "propertydisposal/AddPropertyDisposalItem",
            this.disposeForm
          )
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            var index = this.tableData.findIndex(
              (item) => item.id == this.property.id
            );
            this.tableData.splice(index, 1);
            this.showToast("Successfully disposed!", "success");
            this.onReset();
            this.$bvModal.hide("modal-dispose");
            this.returnToTable();
          })
          .catch((err) => {
            this.showToast("Something went wrong - disposing item!", "error");
          });
        this.submitted = false;
      }
    },
    disposeItem() {
      this.onReset();
      this.disposeForm.propertyId = this.property.id;
      this.disposeForm.propertyFinalStatus =
        this.property.propertyInspections[0].propertyStatus;
      this.disposeForm.inspectionDate = new Date(
        this.property.propertyInspections[0].inspectionDateTime
      );
      this.disposeForm.inspectedBy =
        this.property.propertyInspections[0].employee.firstName.concat(
          " ",
          this.property.propertyInspections[0].employee.lastName
        );
      this.modalTitle = "Dispose Item";
      this.$bvModal.show("modal-dispose");
    },
    checkDisposeForm() {
      if (
        this.disposeForm.disposalId === "" ||
        this.disposeForm.disposalId === null ||
        this.disposeForm.accumulatedDepreciation === "" ||
        this.disposeForm.accumulatedDepreciation === null ||
        this.disposeForm.accumulatedImpairmentLosses === "" ||
        this.disposeForm.accumulatedImpairmentLosses === null ||
        this.disposeForm.carryingAmount === "" ||
        this.disposeForm.carryingAmount === null ||
        this.disposeForm.appraisedValue === "" ||
        this.disposeForm.appraisedValue === null ||
        this.disposeForm.propertyFinalStatus === "" ||
        this.disposeForm.propertyFinalStatus === null ||
        this.disposeForm.inspectionDate === "" ||
        this.disposeForm.inspectionDate === null ||
        this.disposeForm.inspectedBy === "" ||
        this.disposeForm.inspectedBy === null
      ) {
        return true;
      } else return false;
    },
    getEmployee(type) {
      this.$refs.employee.getAllSelections();
      this.$bvModal.show("employee-modal");
      this.getEmployeeType = type;
    },
    dropEmployee(data) {
      var firstname = data.firstName;
      var lastname = data.lastName;
      this.employeeName = firstname.concat(" ", lastname);
      this.form.employeeId = data.id;
      this.form.employee = data;
    },
    getExternalEmployee(type) {
      this.$refs.externalemployee.resetData();
      this.$bvModal.show("externalEmployee-modal");
      this.getEmployeeType = type;
    },
    dropExternalEmployee(data) {
      this.assignmentHistoryEmployeeData = data;
    },
    getLocation() {
      this.$refs.location.getData(this.campusId);
      this.$bvModal.show("location-modal");
    },
    dropLocation(data) {
      this.assignmentHistoryLocationData = data;
    },
    getDisposal() {
      this.$refs.disposal.getData();
      this.$bvModal.show("disposal-modal");
    },
    dropDisposal(data) {
      this.disposeForm.disposalId = data.id;
      this.disposalName = data.description;
    },
    viewInspect(row) {
      if (this.$refs.carousel) {
        this.property = cloneDeep(row);
        this.property.propertyInspections.forEach((inspect) => {
          inspect.inspectionFiles = [];
          inspect.attachmentLoading = true;
          this.$store
            .dispatch("filemanager/GetFiles", {
              id: inspect.id,
              type: this.uploadOptions.type,
            })
            .then((res) => {
              inspect.attachmentLoading = false;
              inspect.inspectionFiles = res.data;
            })
            .catch(() => {
              inspect.attachmentLoading = false;
              this.showToast(
                "Something went wrong - Getting documents!",
                "error"
              );
            });
        });
        this.inspection = true;
        this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
      }
    },
    returnToTable() {
      if (this.$refs.carousel) {
        this.inspection = false;
        this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
      }
    },
    checkLength(array) {
      if (array?.length) return true;
    },
    checkInspection(array) {
      if (this.checkLength(array)) {
        var count = 0;
        array.forEach((inspection) => {
          if (inspection.status == "PENDING") count++;
        });
        if (count == 0) return true;
      }
    },
    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      row.item.showDetails = !row.item.showDetails;
    },
    uploadDocument(response, property, po) {
      let poIndex = this.tableData.findIndex(
        (item) => item.poNumber == po.poNumber
      );
      let propertyindex = this.tableData[poIndex].details.findIndex(
        (item) => item.id == property.id
      );
      this.tableData[poIndex].details[propertyindex].propertyFiles.push(
        response
      );
    },
    openDocument(x) {
      this.readFile(x.id);
    },
    removeFile(props, property, po) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let poIndex = this.tableData.findIndex(
                (item) => item.poNumber == po.poNumber
              );
              let propertyindex = this.tableData[poIndex].details.findIndex(
                (item) => item.id == property.id
              );
              let itemIndex = this.tableData[poIndex].details[
                propertyindex
              ].propertyFiles.findIndex((item) => item.id == props.id);
              this.tableData[poIndex].details[
                propertyindex
              ].propertyFiles.splice(itemIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    propertyNumberWidth(number) {
      if (number < 100) return "min-width: 35px";
      else if (number < 1000) return "min-width: 50px";
      else if (number < 10000) return "min-width: 60px";
      else return "min-width: 75px";
    },
  },
};
</script>

<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <carousel
      ref="carousel"
      class="events navs-carousel"
      id="timeline-carousel"
      :navigation-enabled="false"
      :pagination-enabled="false"
      :perPage="1"
      :autoplay="false"
      :minSwipeDistance="0"
      :mouseDrag="false"
    >
      <slide>
        <div v-if="!inspection">
          <div
            class="card border-4 border-top border-start-0 border-end-0 border-primary"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="d-flex align-items-center h-100">
                    <h5 class="mb-0">List of Properties for Inspection</h5>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex float-end">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter me-1"
                    >
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          autocomplete="off"
                          v-model="filter"
                          type="search"
                          @input="currentPage = 1"
                          placeholder="Search Property..."
                          class="form-control"
                        ></b-form-input>
                      </label>
                    </div>
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-select
                          class="form-select"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptionsLg"
                        >
                        </b-form-select>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="custom-table-responsive mb-0 mt-2">
                <b-table
                  class="propertyTable datatables target-table"
                  :items="grouped"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :busy="tableBusy"
                  bordered
                  outlined
                  striped
                  show-empty
                >
                  <template #empty>
                    <b-card-header>
                      <div class="text-center">
                        <div v-if="filter != ''">
                          <i class="fas fa-exclamation-triangle me-2"></i>There
                          are no properties matching your request
                        </div>
                        <div v-else>
                          <i class="fas fa-exclamation-triangle me-2"></i>No
                          properties available
                        </div>
                      </div>
                    </b-card-header>
                  </template>
                  <template #table-busy>
                    <b-card-header>
                      <div
                        class="d-flex justify-content-center align-items-center"
                      >
                        <div class="preloader-component me-2">
                          <div class="status">
                            <div class="spinner-chase w-20px h-20px">
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                            </div>
                          </div>
                        </div>
                        <strong>Loading...</strong>
                      </div>
                    </b-card-header>
                  </template>
                  <template #cell(poNumber)="row">
                    <b-card-header
                      header-tag="header"
                      @click="showDtls(row)"
                      class="cursor-pointer border"
                      role="tab"
                    >
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <b class="text-white">{{
                            row.value ? `PO# ${row.value}` : "No Recorded PO"
                          }}</b>
                          <div>
                            {{
                              row.item.supplier
                                ? row.item.supplier
                                : "No Recorded Supplier"
                            }}
                          </div>
                        </div>
                        <div>
                          <i
                            class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
                            :class="{
                              'rotate-90': row.item.rotateChevy,
                            }"
                          ></i>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse :visible="row.item.showDetails">
                      <div v-if="row.item.showDetails">
                        <b-card
                          no-body
                          class="p-3 shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0"
                        >
                          <div class="row mb-1">
                            <div class="col"></div>
                            <div class="col">
                              <div class="d-flex float-end">
                                <div
                                  id="tickets-table_filter"
                                  class="dataTables_filter me-1"
                                >
                                  <label
                                    class="d-inline-flex align-items-center"
                                  >
                                    <b-form-input
                                      autocomplete="off"
                                      v-model="row.item.filter"
                                      type="search"
                                      placeholder="Search Property..."
                                      class="form-control form-control-sm"
                                    ></b-form-input>
                                  </label>
                                </div>
                                <div
                                  id="tickets-table_length"
                                  class="dataTables_length"
                                >
                                  <label
                                    class="d-inline-flex align-items-center mb-0"
                                  >
                                    <b-form-select
                                      class="form-select form-select-sm"
                                      v-model="row.item.perPage"
                                      size="sm"
                                      :options="pageOptionsSm"
                                    >
                                    </b-form-select>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="mb-0">
                            <b-table
                              class="propertyTable datatables target-table"
                              thead-class="d-none"
                              :items="propertyFiltered(row.item)"
                              :fields="propertyFields"
                              responsive="sm"
                              :per-page="row.item.perPage"
                              :current-page="row.item.currentPage"
                              sort-by="id"
                              :sort-desc="false"
                              :busy="row.item.tableBusy"
                              show-empty
                            >
                              <template #empty>
                                <b-card-header>
                                  <div class="text-center">
                                    <div v-if="row.item.filter != ''">
                                      <i
                                        class="fas fa-exclamation-triangle me-2"
                                      ></i
                                      >There are no properties matching your
                                      request
                                    </div>
                                    <div v-else>
                                      <i
                                        class="fas fa-exclamation-triangle me-2"
                                      ></i
                                      >No properties available
                                    </div>
                                  </div>
                                </b-card-header>
                              </template>
                              <template #table-busy>
                                <b-card-header>
                                  <div
                                    class="d-flex justify-content-center align-items-center p-2"
                                  >
                                    <div class="preloader-component me-2">
                                      <div class="status">
                                        <div
                                          class="spinner-chase w-20px h-20px"
                                        >
                                          <div class="chase-dot"></div>
                                          <div class="chase-dot"></div>
                                          <div class="chase-dot"></div>
                                          <div class="chase-dot"></div>
                                          <div class="chase-dot"></div>
                                          <div class="chase-dot"></div>
                                        </div>
                                      </div>
                                    </div>
                                    <strong>Loading...</strong>
                                  </div>
                                </b-card-header>
                              </template>
                              <template #cell(name)="propertyRow">
                                <div class="position-relative ms-1">
                                  <RawData
                                    :data="propertyRow.item"
                                    v-if="$store.state.decrypt.isAdmin()"
                                  />
                                </div>
                                <b-card-header
                                  header-tag="header"
                                  role="tab"
                                  class="border"
                                >
                                  <div
                                    class="d-flex justify-content-between align-items-center"
                                  >
                                    <div class="d-flex align-items-center pe-5">
                                      <div
                                        :style="
                                          propertyNumberWidth(
                                            (currentPage - 1) * perPage +
                                              (propertyRow.index + 1)
                                          )
                                        "
                                        class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                      >
                                        <h3 class="mb-0 position-relative">
                                          {{
                                            (row.item.currentPage - 1) *
                                              row.item.perPage +
                                            (propertyRow.index + 1)
                                          }}
                                        </h3>
                                      </div>
                                      <div class="text-muted">
                                        <h5 class="mb-0">
                                          {{ propertyRow.item.name }}
                                        </h5>
                                        <div style="min-width: max-content">
                                          <small
                                            class="d-flex align-items-center"
                                            >{{
                                              propertyRow.item.propertyNumber &&
                                              propertyRow.item.propertyNumber !=
                                                "Not Indicated"
                                                ? `Property# ${propertyRow.item.propertyNumber}`
                                                : "Not Indicated"
                                            }}
                                            |
                                            <a
                                              href="javascript: void(0);"
                                              class="text-success d-flex align-items-center ms-1"
                                              @click="
                                                propertyRow.item.visible =
                                                  !propertyRow.item.visible
                                              "
                                            >
                                              {{
                                                propertyRow.item.visible
                                                  ? "Hide"
                                                  : "Show"
                                              }}
                                              Details
                                              <i
                                                class="bx bx-chevron-right rotate font-size-14"
                                                :class="{
                                                  'rotate-90':
                                                    propertyRow.item.visible,
                                                }"
                                              ></i>
                                            </a>
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="float-end d-flex align-items-center"
                                    >
                                      <div
                                        class="font-size-12"
                                        style="width: max-content"
                                      >
                                        <a
                                          href="javascript: void(0);"
                                          class="text-info d-flex align-items-center"
                                          @click="viewInspect(propertyRow.item)"
                                        >
                                          View Inspection
                                          <i
                                            class="bx bx-chevron-right rotate font-size-14"
                                          ></i>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </b-card-header>
                                <b-collapse
                                  :visible="propertyRow.item.visible"
                                  role="tabpanel"
                                >
                                  <div v-if="propertyRow.item.visible">
                                    <b-card
                                      no-body
                                      class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0"
                                    >
                                      <Details
                                        :key="`all-details-${propertyRow.item.id}`"
                                        :propertyRow="propertyRow.item"
                                        :ref="`all-details-${propertyRow.item.id}`"
                                      ></Details>
                                      <AssignmentHistory
                                        :key="`all-assignment-${propertyRow.item.id}`"
                                        :propertyRow="propertyRow.item"
                                        :allowAssign="false"
                                        :allowEdit="false"
                                        :allowTransfer="true"
                                        :employeeData="
                                          assignmentHistoryEmployeeData
                                        "
                                        :locationData="
                                          assignmentHistoryLocationData
                                        "
                                        :ref="`all-assignment-${propertyRow.item.id}`"
                                        @getEmployee="
                                          getExternalEmployee($event)
                                        "
                                        @getLocation="getLocation($event)"
                                      ></AssignmentHistory>
                                      <CurrentInventory
                                        :key="`all-inventory-${propertyRow.item.id}`"
                                        :propertyRow="propertyRow.item"
                                        :ref="`all-inventory-${propertyRow.item.id}`"
                                      ></CurrentInventory>
                                      <InspectionHistory
                                        :key="`all-inspection-${propertyRow.item.id}`"
                                        :propertyRow="propertyRow.item"
                                        :ref="`all-inspection-${propertyRow.item.id}`"
                                      ></InspectionHistory>
                                      <Attachments
                                        :key="`all-attachments-${propertyRow.item.id}`"
                                        :propertyRow="propertyRow.item"
                                        :ref="`all-attachments-${propertyRow.item.id}`"
                                      ></Attachments>
                                    </b-card>
                                  </div>
                                </b-collapse>
                              </template>
                            </b-table>
                          </div>
                          <div class="row">
                            <div v-if="propertyRows(row.item) > 0" class="col">
                              Showing
                              {{
                                (row.item.currentPage - 1) * row.item.perPage +
                                1
                              }}
                              -
                              {{
                                propertyRows(row.item) >
                                (row.item.currentPage - 1) * row.item.perPage +
                                  row.item.perPage
                                  ? (row.item.currentPage - 1) *
                                      row.item.perPage +
                                    row.item.perPage
                                  : propertyRows(row.item)
                              }}
                              of {{ propertyRows(row.item) }}
                            </div>
                            <div class="col">
                              <div
                                class="dataTables_paginate paging_simple_numbers float-end"
                              >
                                <ul
                                  class="pagination pagination-rounded mb-0"
                                  style="z-index: -1"
                                >
                                  <b-pagination
                                    v-model="row.item.currentPage"
                                    :total-rows="propertyRows(row.item)"
                                    :per-page="row.item.perPage"
                                  ></b-pagination>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </b-card>
                      </div>
                    </b-collapse>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div v-if="rows > 0" class="col">
                  Showing {{ (currentPage - 1) * perPage + 1 }} -
                  {{
                    rows > (currentPage - 1) * perPage + perPage
                      ? (currentPage - 1) * perPage + perPage
                      : rows
                  }}
                  of {{ rows }}
                </div>
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul
                      class="pagination pagination-rounded mb-0"
                      style="z-index: -1"
                    >
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slide>
      <slide>
        <div v-if="inspection">
          <!-- Add Inspection -->
          <b-modal
            id="modal-standard"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
          >
            <form @submit.prevent="onAdd" class="needs-validation" ref="fcForm">
              <div class="mb-3">
                <label for="inspectionDateTime">Inspection Date</label>
                <date-picker
                  v-model="form.inspectionDateTime"
                  :first-day-of-week="1"
                  lang="en"
                  placeholder="Enter Inspection Date..."
                  :class="{
                    'is-invalid':
                      submitted && $v.form.inspectionDateTime.$error,
                  }"
                ></date-picker>
                <div
                  v-if="submitted && $v.form.inspectionDateTime.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.inspectionDateTime.required"
                    >This value is required.</span
                  >
                </div>
              </div>
              <div class="mb-3">
                <label for="propertyStatus">PPE Condition</label>
                <b-form-select
                  class="form-select"
                  :class="{
                    'is-invalid': submitted && $v.form.propertyStatus.$error,
                  }"
                  v-model="form.propertyStatus"
                >
                  <b-form-select-option value="" disabled
                    >Select Condition...</b-form-select-option
                  >
                  <b-form-select-option value="In good condition"
                    >In good condition</b-form-select-option
                  >
                  <b-form-select-option value="Needing Repair"
                    >Needing Repair</b-form-select-option
                  >
                  <b-form-select-option value="Unserviceable"
                    >Unserviceable</b-form-select-option
                  >
                  <b-form-select-option value="Obsolete"
                    >Obsolete</b-form-select-option
                  >
                  <b-form-select-option value="Expired"
                    >Expired</b-form-select-option
                  >
                  <b-form-select-option value="No longer needed"
                    >No longer needed</b-form-select-option
                  >
                  <b-form-select-option value="Not used since purchase"
                    >Not used since purchase</b-form-select-option
                  >
                </b-form-select>
                <div
                  v-if="submitted && $v.form.propertyStatus.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.propertyStatus.required"
                    >This value is required.</span
                  >
                </div>
              </div>
              <div class="mb-3">
                <label for="assessedValue">Assessed Value</label>
                <input
                  id="assessedValue"
                  type="text"
                  v-model="form.assessedValue"
                  placeholder="Enter Assessed Value..."
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.assessedValue.$error,
                  }"
                  autocomplete="off"
                />
                <div
                  v-if="submitted && $v.form.assessedValue.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.assessedValue.required"
                    >This value is required.</span
                  >
                </div>
              </div>
              <div class="mb-3">
                <label for="inspectionStatus">Remark</label>
                <b-form-select
                  class="form-select"
                  :class="{
                    'is-invalid': submitted && $v.form.inspectionStatus.$error,
                  }"
                  v-model="form.inspectionStatus"
                >
                  <b-form-select-option value="" disabled
                    >Select Remark...</b-form-select-option
                  >
                  <b-form-select-option value="Found at station"
                    >Found at station</b-form-select-option
                  >
                  <b-form-select-option value="Non-existent/missing"
                    >Non-existent/missing</b-form-select-option
                  >
                  <b-form-select-option value="Transferred"
                    >Transferred</b-form-select-option
                  >
                </b-form-select>
                <div
                  v-if="submitted && $v.form.inspectionStatus.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.inspectionStatus.required"
                    >This value is required.</span
                  >
                </div>
              </div>
              <div class="mb-3">
                <label for="employee">Inspected By</label>
                <b-input-group>
                  <template #append>
                    <b-button
                      @click="getEmployee('inspect')"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    type="text"
                    disabled
                    placeholder="Search Employee..."
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.form.employeeId.$error,
                    }"
                    v-model="employeeName"
                  />
                </b-input-group>
                <div
                  v-if="submitted && $v.form.employeeId.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.employeeId.required"
                    >This value is required.</span
                  >
                </div>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                  Create Inspection
                </button>
              </div>
            </form>
          </b-modal>
          <!-- Dispose -->
          <b-modal
            id="modal-dispose"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
          >
            <form
              @submit.prevent="onDispose"
              class="needs-validation"
              ref="fcForm"
            >
              <div class="mb-3">
                <label for="propertyFinalStatus">Property Final Status</label>
                <input
                  id="propertyFinalStatus"
                  type="text"
                  v-model="disposeForm.propertyFinalStatus"
                  placeholder="Enter Property Final Status..."
                  class="form-control"
                  :class="{
                    'is-invalid':
                      submitted &&
                      (disposeForm.propertyFinalStatus == '' ||
                        disposeForm.propertyFinalStatus == null),
                  }"
                  autocomplete="off"
                />
                <div
                  v-if="
                    submitted &&
                    (disposeForm.propertyFinalStatus == '' ||
                      disposeForm.propertyFinalStatus == null)
                  "
                  class="invalid-feedback"
                >
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="inspectionDate">Inspection Date</label>
                <date-picker
                  v-model="disposeForm.inspectionDate"
                  :first-day-of-week="1"
                  lang="en"
                  placeholder="Enter Inspection Date..."
                  :class="{
                    'is-invalid':
                      submitted &&
                      (disposeForm.inspectionDate == '' ||
                        disposeForm.inspectionDate == null),
                  }"
                ></date-picker>
                <div
                  v-if="
                    submitted &&
                    (disposeForm.inspectionDate == '' ||
                      disposeForm.inspectionDate == null)
                  "
                  class="invalid-feedback"
                >
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="inspectedBy">Inspected By</label>
                <input
                  id="inspectedBy"
                  type="text"
                  v-model="disposeForm.inspectedBy"
                  placeholder="Enter Inspected By..."
                  class="form-control"
                  :class="{
                    'is-invalid':
                      submitted &&
                      (disposeForm.inspectedBy == '' ||
                        disposeForm.inspectedBy == null),
                  }"
                  autocomplete="off"
                />
                <div
                  v-if="
                    submitted &&
                    (disposeForm.inspectedBy == '' ||
                      disposeForm.inspectedBy == null)
                  "
                  class="invalid-feedback"
                >
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="employee">Disposal</label>
                <b-input-group>
                  <template #append>
                    <b-button @click="getDisposal" variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    type="text"
                    disabled
                    placeholder="Search Disposal..."
                    class="form-control"
                    :class="{
                      'is-invalid':
                        submitted &&
                        (disposeForm.disposalId == '' ||
                          disposeForm.disposalId == null),
                    }"
                    v-model="disposalName"
                  />
                </b-input-group>
                <div
                  v-if="
                    submitted &&
                    (disposeForm.disposalId == '' ||
                      disposeForm.disposalId == null)
                  "
                  class="invalid-feedback"
                >
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="accumulatedDepreciation"
                  >Accumulated Depreciation</label
                >
                <masked-input
                  id="accumulatedDepreciation"
                  type="text"
                  v-model="disposeForm.accumulatedDepreciation"
                  placeholder="Enter Accumulated Depreciation..."
                  class="form-control"
                  :class="{
                    'is-invalid':
                      submitted &&
                      (disposeForm.accumulatedDepreciation == '' ||
                        disposeForm.accumulatedDepreciation == null),
                  }"
                  autocomplete="off"
                  :mask="currencyMask"
                ></masked-input>
                <div
                  v-if="
                    submitted &&
                    (disposeForm.accumulatedDepreciation == '' ||
                      disposeForm.accumulatedDepreciation == null)
                  "
                  class="invalid-feedback"
                >
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="accumulatedImpairmentLosses"
                  >Accumulated Impairment Losses</label
                >
                <masked-input
                  id="accumulatedImpairmentLosses"
                  type="text"
                  v-model="disposeForm.accumulatedImpairmentLosses"
                  placeholder="Enter Accumulated Impairment Losses..."
                  class="form-control"
                  :class="{
                    'is-invalid':
                      submitted &&
                      (disposeForm.accumulatedImpairmentLosses == '' ||
                        disposeForm.accumulatedImpairmentLosses == null),
                  }"
                  autocomplete="off"
                  :mask="currencyMask"
                ></masked-input>
                <div
                  v-if="
                    submitted &&
                    (disposeForm.accumulatedImpairmentLosses == '' ||
                      disposeForm.accumulatedImpairmentLosses == null)
                  "
                  class="invalid-feedback"
                >
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="carryingAmount">Carrying Amount</label>
                <masked-input
                  id="carryingAmount"
                  type="text"
                  v-model="disposeForm.carryingAmount"
                  placeholder="Enter Carrying Amount..."
                  class="form-control"
                  :class="{
                    'is-invalid':
                      submitted &&
                      (disposeForm.carryingAmount == '' ||
                        disposeForm.carryingAmount == null),
                  }"
                  autocomplete="off"
                  :mask="currencyMask"
                ></masked-input>
                <div
                  v-if="
                    submitted &&
                    (disposeForm.carryingAmount == '' ||
                      disposeForm.carryingAmount == null)
                  "
                  class="invalid-feedback"
                >
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="appraisedValue">Appraised Value</label>
                <masked-input
                  id="appraisedValue"
                  type="text"
                  v-model="disposeForm.appraisedValue"
                  placeholder="Enter Appraised Value..."
                  class="form-control"
                  :class="{
                    'is-invalid':
                      submitted &&
                      (disposeForm.appraisedValue == '' ||
                        disposeForm.appraisedValue == null),
                  }"
                  autocomplete="off"
                  :mask="currencyMask"
                ></masked-input>
                <div
                  v-if="
                    submitted &&
                    (disposeForm.appraisedValue == '' ||
                      disposeForm.appraisedValue == null)
                  "
                  class="invalid-feedback"
                >
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="remarks">Remarks</label>
                <textarea
                  id="remarks"
                  rows="2"
                  v-model="disposeForm.remarks"
                  placeholder="Enter Remarks..."
                  class="form-control"
                  autocomplete="off"
                ></textarea>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn btn-primary">Dispose</button>
              </div>
            </form>
          </b-modal>
          <b-row class="mb-2">
            <b-col sm="6">
              <div class="d-flex align-items-center">
                <a
                  href="javascript:void(0);"
                  class="me-2"
                  @click="returnToTable()"
                  ><i class="bx bx-left-arrow-alt fs-2"></i
                ></a>
                <h4 class="m-0">Inspection History</h4>
              </div>
            </b-col>
            <b-col sm="6">
              <button
                type="button"
                @click="createInspection()"
                class="btn btn-md btn-info d-flex align-items-center float-end"
              >
                <i class="bx bx-plus fs-6"></i>Create New
              </button>
            </b-col>
          </b-row>
          <div
            class="card border-4 border-top border-start-0 border-end-0 border-primary"
          >
            <div class="card-body">
              <div class="m-1 mt-2 mb-3 d-flex justify-content-between">
                <div>
                  <h3 class="m-0">{{ property.name }}</h3>
                  <div>{{ property.propertyNumber }}</div>
                </div>
                <div
                  v-if="checkInspection(property.propertyInspections)"
                  class="mt-3"
                >
                  <button
                    type="button"
                    @click="disposeItem()"
                    class="btn btn-sm btn-danger d-flex align-items-center float-end"
                  >
                    <i class="bx bx-trash fs-6 me-1"></i>Dispose Item
                  </button>
                </div>
              </div>
              <div>
                <div class="card p-3 me-1">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="d-flex align-items-center">
                        Condition:
                        <h6 class="mb-0 ms-2">{{ property.condition }}</h6>
                      </div>
                      <div class="d-flex align-items-center">
                        Amount:
                        <h6 class="mb-0 ms-2">
                          {{ formatCurrency(property.amount) }}
                        </h6>
                      </div>
                      <div class="d-flex align-items-center">
                        Brand:
                        <h6 class="mb-0 ms-2">
                          {{ property.brand }}
                        </h6>
                      </div>
                      <div class="d-flex align-items-center">
                        Categoty:
                        <h6 class="mb-0 ms-2">
                          {{ property.itemCategory.name }}
                        </h6>
                      </div>
                      <div class="d-flex align-items-center">
                        Supplier:
                        <h6 class="mb-0 ms-2">{{ property.supplier }}</h6>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex align-items-center">
                        Current Value:
                        <h6
                          class="mb-0 ms-2"
                          :class="{
                            'text-warning': property.currentValue,
                          }"
                        >
                          {{ formatCurrency(property.currentValue) }}
                        </h6>
                      </div>
                      <div class="d-flex align-items-center">
                        Life Span in Years:
                        <h6 class="mb-0 ms-2">
                          {{
                            property.lifespanInYears > 0
                              ? property.lifespanInYears
                              : "Not Indicated"
                          }}
                        </h6>
                      </div>
                      <div class="d-flex align-items-center">
                        Salvage Value:
                        <h6 class="mb-0 ms-2">
                          {{ formatCurrency(property.salvageValue) }}
                        </h6>
                      </div>
                      <div class="d-flex align-items-center">
                        Yearly Depreciation:
                        <h6
                          class="mb-0 ms-2"
                          :class="{
                            'text-danger': property.yearlyDepreciation,
                          }"
                        >
                          {{ property.yearlyDepreciation }}%
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="loading">
                <div class="card p-3 me-1">
                  <div
                    class="p-3 d-flex align-items-center justify-content-center"
                  >
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-25px h-25px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <h5 class="mb-0">Loading...</h5>
                  </div>
                </div>
              </div>
              <div v-else-if="!checkLength(property.propertyInspections)">
                <div class="card p-3 me-1">
                  <div
                    class="p-3 d-flex align-items-center justify-content-center"
                  >
                    <h5 class="text-muted">
                      <i class="fas fa-exclamation-triangle me-2"></i>No Prior
                      History
                    </h5>
                  </div>
                </div>
              </div>
              <b-card-body class="text-muted" v-else>
                <ul
                  class="verti-timeline list-unstyled ms-4"
                  v-for="y in property.propertyInspections"
                  :key="y.id"
                >
                  <li
                    class="event-list"
                    :class="{
                      active: y.status == 'PENDING',
                    }"
                  >
                    <div class="event-timeline-dot pt-3">
                      <i
                        v-if="y.status == 'PENDING'"
                        class="bx bxs-right-arrow-circle font-size-18 bx-fade-right"
                      ></i>
                      <i
                        v-else
                        class="bx bx-right-arrow-circle font-size-18"
                      ></i>
                    </div>
                    <div class="media">
                      <div
                        class="d-flex justify-content-between align-items-center pt-3 ms-4 me-3"
                        style="width: 125px"
                      >
                        <div>
                          <b class="font-size-16">
                            {{
                              formatDateShort(new Date(y.inspectionDateTime))
                            }}
                          </b>
                        </div>
                        <div>
                          <i
                            class="bx bx-right-arrow-alt font-size-16 text-info align-middle ms-2"
                          ></i>
                        </div>
                      </div>
                      <div class="media-body">
                        <div class="card p-3">
                          <div class="row">
                            <div class="col-md-4 border-end border-3">
                              <div class="float-end ms-2">
                                <i
                                  class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                                  :id="`inspection-popover-${y.id}`"
                                  tabindex="0"
                                ></i>
                                <b-popover
                                  :target="`inspection-popover-${y.id}`"
                                  triggers="click blur"
                                  placement="leftbottom"
                                  variant="secondary"
                                  custom-class="p-0"
                                >
                                  <b-list-group class="w-100 fit">
                                    <b-list-group-item
                                      v-if="y.status == 'PENDING'"
                                      button
                                      action
                                      class="d-flex align-items-center text-info"
                                      @click="updateInspection(y)"
                                      ><i
                                        class="mdi mdi-update font-size-18 me-1"
                                      ></i
                                      >Update Inspection</b-list-group-item
                                    >
                                    <b-list-group-item
                                      v-if="y.status == 'PENDING'"
                                      button
                                      action
                                      class="d-flex align-items-center text-success"
                                      @click="postInspection(y)"
                                      ><i
                                        class="bx bx-check-circle font-size-18 me-1"
                                      ></i
                                      >Post Inspection</b-list-group-item
                                    >
                                    <b-list-group-item
                                      v-if="y.status == 'POSTED'"
                                      button
                                      action
                                      class="d-flex align-items-center text-warning"
                                      @click="unpostInspection(y)"
                                      ><i
                                        class="bx bx-x-circle font-size-18 me-1"
                                      ></i
                                      >Unpost Inspection</b-list-group-item
                                    >
                                    <b-list-group-item
                                      v-if="y.status == 'PENDING'"
                                      button
                                      action
                                      class="d-flex align-items-center text-danger"
                                      @click="deleteInspection(y)"
                                      ><i
                                        class="mdi mdi-trash-can font-size-18 me-1"
                                      ></i
                                      >Delete</b-list-group-item
                                    >
                                  </b-list-group>
                                </b-popover>
                              </div>
                              <div class="font-size-12 mb-1">
                                Property Status:
                                <b class="font-size-14">{{
                                  y.propertyStatus
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Assessed Value:
                                <b class="font-size-14">{{
                                  y.assessedValue
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Inspection Status:
                                <b class="font-size-14">{{
                                  y.inspectionStatus
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Inspected By:
                                <b v-if="y.employee" class="font-size-14">
                                  {{
                                    y.employee.firstName
                                      .charAt(0)
                                      .toUpperCase() +
                                    y.employee.firstName.slice(1)
                                  }}
                                  {{
                                    y.employee.middleName
                                      ? `${y.employee.middleName
                                          .charAt(0)
                                          .toUpperCase()}.`
                                      : ""
                                  }}
                                  {{
                                    y.employee.lastName
                                      .charAt(0)
                                      .toUpperCase() +
                                    y.employee.lastName.slice(1)
                                  }}</b
                                >
                                <b v-else class="font-size-14">n/a</b>
                              </div>
                              <div class="font-size-16 mb-1">
                                <span
                                  v-if="y.status == 'PENDING'"
                                  class="badge bg-warning bg-soft text-warning"
                                  ><b>{{ y.status }}</b></span
                                >
                                <span
                                  v-if="y.status == 'POSTED'"
                                  class="badge bg-success"
                                  ><b>{{ y.status }}</b></span
                                >
                              </div>
                            </div>
                            <div class="col-md-8">
                              <div
                                class="d-flex align-items-center justify-content-between mb-3"
                              >
                                <div class="d-flex">
                                  <div class="font-size-13 pt-3">
                                    Attachments:
                                  </div>
                                </div>
                                <div class="">
                                  <a
                                    href="javascript:void(0);"
                                    class="text-primary border-primary border p-2"
                                    :id="`posted-document${y.id}`"
                                    @click="y.addDocu = true"
                                    ><i class="bx bx-plus"></i>Upload
                                    Documents</a
                                  >
                                  <upload-popover
                                    :option="uploadOptions"
                                    :sourceId="y.id"
                                    @uploaded="uploadDocument($event, y.id)"
                                    :showPV="y.addDocu"
                                    @closePopover="y.addDocu = false"
                                    :dzId="`dropzone-posted${y.id}`"
                                    :pvId="`posted-document${y.id}`"
                                  ></upload-popover>
                                </div>
                              </div>
                              <b-row style="max-height: 250px; overflow: auto">
                                <b-col
                                  sm="4"
                                  v-for="(z, index) in y.inspectionFiles"
                                  :key="z.id"
                                  class="mb-2"
                                >
                                  <div
                                    class="position-relative cursor-pointer"
                                    :style="`z-index: ${
                                      y.inspectionFiles.length - index
                                    }`"
                                  >
                                    <div class="float-end ms-2">
                                      <b-dropdown
                                        id="dropdown-dropleft"
                                        right
                                        variant="link"
                                        toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                        menu-class="dropdown-menu-end"
                                        no-caret
                                      >
                                        <template #button-content>
                                          <i
                                            class="mdi mdi-dots-horizontal"
                                          ></i>
                                        </template>
                                        <b-dropdown-item
                                          @click="openDocument(z)"
                                          ><i
                                            class="bx bx-link-external me-1"
                                          ></i
                                          >Open</b-dropdown-item
                                        >
                                        <b-dropdown-item
                                          variant="danger"
                                          @click="removeFile(z.id, y.id)"
                                          ><i class="bx bx-trash me-1"></i
                                          >Remove</b-dropdown-item
                                        >
                                      </b-dropdown>
                                    </div>
                                    <div
                                      class="border p-3"
                                      @click="openDocument(z)"
                                    >
                                      <div>
                                        <div class="avatar-xs me-3 mb-2">
                                          <div
                                            class="avatar-title bg-transparent rounded"
                                          >
                                            <i
                                              v-if="
                                                z.fileType.includes('image')
                                              "
                                              class="mdi mdi-image font-size-24 text-purple"
                                            ></i>
                                            <i
                                              v-if="
                                                z.fileType.includes(
                                                  'application'
                                                )
                                              "
                                              class="mdi mdi-file-pdf-outline font-size-24 text-danger"
                                            ></i>
                                          </div>
                                        </div>
                                        <div class="d-flex">
                                          <div class="overflow-hidden me-auto">
                                            <h5
                                              class="font-size-14 text-truncate mb-1"
                                            >
                                              {{ z.description }}
                                            </h5>
                                            <p class="text-muted mb-0">
                                              {{
                                                formatDateWithTime(
                                                  new Date(z.dateTimeUploaded)
                                                )
                                              }}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </b-col>
                              </b-row>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </b-card-body>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
    <Employee ref="employee" @dropData="dropEmployee($event)"></Employee>
    <ExternalEmployee
      ref="externalemployee"
      @dropData="dropExternalEmployee($event)"
    ></ExternalEmployee>
    <Location ref="location" @dropData="dropLocation($event)"></Location>
    <Disposal ref="disposal" @dropData="dropDisposal($event)"></Disposal>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.slideUp-enter-active {
  animation: slide-up 0.5s;
}

.slideUp-leave-active {
  animation: slide-up 0.5s reverse;
}

.slide-enter-active {
  animation: slide-in 0.3s;
}

.slide-leave-active {
  animation: slide-in 0.3s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-up {
  0% {
    transform: translateY(-30px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
